<template>
  <b-overlay :show="searchingConfig">
    <form
      autocomplete="off"
      data-vv-scope="flow-part-1"
    >
      <div class="row mb-3">
        <div class="col-12">
          <h4>Datos para el flujo</h4>
          <span v-if="wizardData.fileCategory === 'numInt' || wizardData.fileCategory === 'numOf'">
            Este expediente
            <span v-if="wizardData.fileCategory === 'numInt'">
              podrá tener numeración interna
            </span>
            <span v-if="wizardData.fileCategory === 'numOf'">
              podrá ser tramitado por Oficina de Partes
            </span>
          </span>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Nombre para el flujo (*)"
            maxlength="120"
            name="name"
            v-model="step.name"
            :danger="errors.has('flow-part-1.name')"
            :danger-text="errors.first('flow-part-1.name')"
            v-validate="'required'"
          />
        </div>
        <div class="col-md-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Resumen (*)"
            name="description"
            v-model="step.description"
            :danger="errors.has('flow-part-1.description')"
            :danger-text="errors.first('flow-part-1.description')"
            v-validate="'required'"
            maxlength="550"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6 mt-3">
          <BooleanParameter
            :is-approval-sign="true"
            :disabled="disableSignaturePosition"
            param-id="aprobaciones.firmas.ubicacion"
            v-model="step.setSignaturePosition"
            default-false
            @input="onSetSignaturePositionChange"
            data-cy="setSignaturePosition"
          />
        </div>
        <div
          class="col-md-6 col-xs-12 col-sm-12 mt-3"
          v-if="documentHasOficeActions"
        >
          <b-form-group
            label="Oficina de partes que numera (*)"
          >
            <v-select
              data-vv-as="oficina que numera"
              v-validate="'required'"
              name="numerationOffice"
              :danger="errors.has('flow-part-1.numerationOffice')"
              :danger-text="errors.first('flow-part-1.numerationOffice')"
              :disabled="step.office.list.length === 1"
              v-model="step.office.selected"
              :options="step.office.list"
              @input="selectNumerationOffice"
              placeholder="Selecciona una oficina"
            >
              <template slot="no-options">
                no hay tipos de documentos para el criterio de búsqueda
              </template>
            </v-select>
            <span
              class="text-danger"
              v-if="errors.has('flow-part-1.numerationOffice')"
            >
              {{ errors.first('flow-part-1.numerationOffice')||'' }}
            </span>
            <span
              v-for="(action,$index) in step.actions"
              :key="$index+'-action'"
              class="badge badge-primary ml-3"
            >
            {{ action.action }}
          </span>
          </b-form-group>
        </div>
      </div>
    </form>
    <form data-vv-scope="flow-part-2">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Detalle del flujo</h4>
          <small class="text-primary">
            Este documento debe ser tramitado por una oficina,
            pero no te preocupes, se colocará automáticamente
          </small>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-3">
          <vs-select
            class="w-100"
            label="Tipo de paso (*)"
            name="stepType"
            autocomplete
            v-model="stepType"
            :danger="errors.has('flow-part-2.stepType')"
            :danger-text="errors.first('flow-part-2.stepType')"
            v-validate="'required'"
            @change="searchOffice"
          >
            <vs-select-item
              :value="stepTypes.USER"
              text="Usuario"
            />
            <vs-select-item
              v-if="!documentHasOficeActions  && wizardData.fileCategory !== 'int'"
              :value="stepTypes.OFFICE"
              text="Oficina"
            />
          </vs-select>
        </div>
        <div
          class="col-6"
          v-if="stepType === stepTypes.OFFICE"
        >
          <list-offices
            class="w-100 mb-1"
            autocomplete
            label="Oficina del responsable (*)"
            name="groupStep"
            v-model="groupStep"
            data-vv-as="oficina"
            :typeList="stepType"
            validate-lider
            withFilters
            :officeType="wizardData.fileCategory"
            ref="groupStep"
            :danger="errors.has('flow-part-2.groupStep')"
            :danger-text="errors.first('flow-part-2.groupStep')"
            v-validate="{ required: stepType === this.stepTypes.OFFICE }"
          />
          <small class="text-danger">
            Si le falta una oficina, favor notificar al equipo de Soporte
            para que verifiquen que esté correctamente configurada
          </small>
        </div>
        <div
          class="col-6"
          v-if="stepType === stepTypes.USER"
        >
          <list-user
            class="w-100"
            autocomplete
            label="Usuario (*)"
            name="userStep"
            withFilters
            v-model="userStep"
            ref="userStep"
            :danger="errors.has('flow-part-2.userStep')"
            :danger-text="errors.first('flow-part-2.userStep')"
            v-validate="{ required: stepType === stepTypes.USER }"
          />
        </div>
        <div
          class="col-3"
          v-if="stepType !== stepTypes.OFFICE"
        >
          <vs-select
            class="w-100"
            label="Tipo de rol (*)"
            name="rolType"
            autocomplete
            v-model="rolType"
            :danger="errors.has('flow-part-2.rolType')"
            :danger-text="errors.first('flow-part-2.rolType')"
            v-validate="'required'"
          >
            <vs-select-item
              :value="rolTypes.APPROVER"
              text="Aprobador"
            />
            <vs-select-item
              :value="rolTypes.VIEWER"
              text="Visador"
            />
            <vs-select-item
              :value="rolTypes.SIGNER"
              text="Firmante"
            />
          </vs-select>
          <div class="text-right">
            info
            <b-button
              size="sm"
              class="btn-icon rounded-circle mt-1"
              id="popover-button-default"
              variant="flat-primary"
            >
              <feather-icon icon="InfoIcon"/>
            </b-button>
            <InfoRolType/>
          </div>
        </div>
        <div
          class="col-3"
          v-if="stepType === stepTypes.OFFICE"
        >
          <vs-select
            class="w-100"
            autocomplete
            label="Tipo de rol"
            name="rolType"
            v-model="rolType"
            :danger="errors.has('flow-part-2.rolType')"
            :danger-text="errors.first('flow-part-2.rolType')"
            v-validate="'required'"
          >
            <vs-select-item
              :value="rolTypes.SIGNER"
              text="Numerar/Tramitar"
            />
          </vs-select>
          <div class="text-right">
            info
            <b-button
              size="sm"
              class="btn-icon rounded-circle mt-1"
              id="popover-button-default"
              variant="flat-primary"
            >
              <feather-icon icon="InfoIcon"/>
            </b-button>
            <b-popover
              target="popover-button-default"
              triggers="focus"
              placement="top"
            >
              <template #title>
                <span>Tipos de roles!</span>
              </template>
              <span>
                  <b>+ Firmante:</b> Permite firmar documentos, esto cuenta como la aprobación.
                </span>
            </b-popover>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <vs-button
            color="primary"
            icon="add"
            :disabled="blockButton"
            v-on:click="addStep()"
            data-cy="add-step"
          >
            Agregar Paso
          </vs-button>
        </div>
      </div>
      <div
        class="row mb-3"
        v-if="step.steps.length"
      >
        <div
          class="col-3"
          v-for="(step, index) in step.steps"
          :key="`step-${index}`"
        >
          <div class="step-wrapper">
            <span class="step-number">{{ step.stepNumber }}</span>
            <span class="step-delete">
              <vs-icon
                icon="highlight_off"
                size="small"
                bg="white"
                round
                @click="removeStep(step)"
              />
            </span>
            <div class="text-center step-name">
              {{ step.responsibleName }}
            </div>
            <div class="step-type">
              <span v-if="step.stepType === stepTypes.USER">
                usuario
              </span>
              <span v-if="step.stepType === stepTypes.OFFICE">
                oficina
              </span>
            </div>
            <div class="step-rol">
              <span v-if="step.rolType === rolTypes.APPROVER">
                aprobador
              </span>
              <span v-if="step.stepType !== stepTypes.OFFICE && step.rolType === rolTypes.SIGNER">
                firmante
              </span>
              <span v-if="step.rolType === rolTypes.VIEWER">
                visador
              </span>
              <span v-if="step.stepType === stepTypes.OFFICE && step.rolType === rolTypes.SIGNER">
                num/tramitar
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="error.message !== ''"
        class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
        style="height: 32px;"
      >
          <span class="span-text-validation">
            {{ error.message }}
          </span>
      </div>
    </form>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListUser from '@/febos/chile/lists/components/ListUser';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import BooleanParameter from '@/febos/chile/tools/components/BooleanParameter';
import { getSheetsConfig } from '@/febos/servicios/api/dnt.api';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import ActionsMixin from '@/febos/chile/dnt/mixins/ActionsMixin';
import InfoRolType from '@/febos/chile/approvals/wizardFlow/components/InfoRolType';

export default {
  name: 'StepFlow',
  mixins: [WizardStep, ActionsMixin],
  components: {
    InfoRolType,
    BooleanParameter,
    ListUser,
    ListOffices
  },
  data() {
    return {
      stepOffice: {},
      error: {
        message: ''
      },
      rolTypes: RolTypes,
      stepTypes: StepTypes,
      step: {
        fileMime: 'application/pdf',
        fileDate: Vue.moment().format('YYYY-MM-DD HH:mm:ss'),
        fileId: this.$route.params.id,
        name: '',
        description: '',
        pdfStamp: false,
        steps: [],
        file: '',
        setSignaturePosition: false,
        signaturesDropped: {},
        mainFile: {
          name: '',
          path: ''
        },
        actions: [],
        ...this.draft
      },
      stepType: StepTypes.USER,
      rolType: '',
      groupStep: '',
      userStep: '',
      blockButton: false,
      searchingConfig: false,
      documents: []
    };
  },
  watch: {
    wizardData(newValue) {
      this.step.name = newValue.fileResumen;
      this.removeSignaturesDropped();
    }
  },
  computed: {
    ...mapGetters('List', [
      'groupUsersState',
      'userGroupsState',
      'officesState'
    ]),
    ...mapGetters('Dnts', ['wizardData']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Management', ['workerData']),
    ...mapGetters('Usuario', ['currentUser'])
  },
  methods: {
    ...mapActions('List', ['fetchUserGroups', 'fetchOffices']),
    ...mapActions('Management', ['getWorkerData']),
    ...mapActions('Approvals', [
      'removeSignaturesDropped'
    ]),
    clearValidation() {
      this.blockButton = false;
    },
    searchOffice() {
      this.clearValidation();
      if (this.stepType === StepTypes.OFFICE) {
        const typeOffice = this.wizardData.fileCategory === 'numOf' ? 'ext' : 'int';
        this.groupStep = typeOffice === 'ext'
          ? this.workerData.oficina_ext?.valor || ''
          : this.workerData.oficina_int?.valor || '';
      }
    },
    removeStep(stepRemove) {
      this.blockButton = false;
      this.error.message = '';
      this.step.steps = this.step.steps.filter((step) => step.stepNumber !== stepRemove.stepNumber)
        .map((stepMap, index) => ({
          ...stepMap,
          stepNumber: index + 1
        }));
    },
    async addStep() {
      this.error.message = '';
      this.blockButton = true;
      const isValid = await this.validateForm('flow-part-2');

      if (!isValid) {
        this.blockButton = false;
        return;
      }

      if (this.step.steps.find((step) => step.stepType === StepTypes.OFFICE)) {
        this.error.message = 'Oops! El último paso debe ser la oficina y ya la agregaste';
        return;
      }

      const responsibleStep = (
        this.stepType === StepTypes.GROUP || this.stepType === StepTypes.OFFICE
      )
        ? this.$refs.groupStep?.getOption()
        : this.$refs.userStep?.getOption();

      const step = {
        stepType: this.stepType,
        rolType: this.rolType,
        stepNumber: this.step.steps.length + 1,
        responsibleName: responsibleStep.label,
        responsibleId: responsibleStep.id,
        responsibleEmail: responsibleStep.email || ''
      };

      this.step.steps.push(step);

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.blockButton = false;
      await this.$validator.reset();
    },
    async addStepOffice(office) {
      const step = {
        stepType: StepTypes.OFFICE,
        rolType: this.rolTypes.SIGNER,
        stepNumber: this.step.steps.length + 1,
        responsibleName: office.label,
        responsibleId: office.id,
        responsibleEmail: ''
      };

      this.stepOffice = step;

      this.stepType = this.stepTypes.USER;
      this.rolType = '';
      this.groupStep = '';
      this.userStep = '';
      this.blockButton = false;
    },
    setOffice() {
      const officeType = (this.wizardData.fileCategory === 'numOf' || this.wizardData.fileCategory === 'ext')
        ? 'ext' : 'int';
      const offices = this.workerData.oficina_ext.valor
        ? this.officesState.list.filter(
          (office) => office.id === this.workerData.oficina_ext?.valor
        )
        : this.officesState.list.filter(
          (group) => group.type === officeType
        ).filter((office) => (
          (office.users > 1 && office.hasLead === 'Y')
          || (office.users === 1 && (office.hasLead === 'Y' || office.hasLead === 'N'))
        ));
      this.step.office.list = offices;
      if (offices.length === 1) {
        this.addStepOffice(offices[0]);
      }
    },
    async isValid() {
      if (this.searchingConfig) {
        return false;
      }
      try {
        this.searchingConfig = true;
        const flowValidation = await Promise.all([
          this.validateForm('flow-part-1')
        ]);

        if (flowValidation.some((step) => !step)) {
          return false;
        }
        if (!this.step.steps.length) {
          this.error.message = 'Debes agregar al menos un paso';
          return false;
        }

        const { documentHasOficeActions } = this;
        if (documentHasOficeActions) {
          const isNumerationValid = await this.validNumerationActionConfigDocNum();
          if (!isNumerationValid) {
            this.error.message = 'No existe configuración de numeración para este documento';
            return false;
          }
          const hasSigner = this.validIfStepsHasSigner();
          if (!hasSigner) {
            this.error.message = 'No se puede realizar las acciones de la oficina con pasos sin firmante';
            return false;
          }
        } else {
          let officeId = (
            this.step.steps.find(
              (step) => step.stepType === this.stepTypes.OFFICE
            ) || {}
          ).responsibleId;

          if (this.step.steps.length && this.step.steps[0].stepType === StepTypes.OFFICE) {
            this.error.message = 'Oops! No puedes agregar una oficina como primer paso';
            return false;
          }
          if (!officeId) {
            this.step.steps.push(this.stepOffice);
          }
          officeId = (this.step.steps.find(
            (step) => step.stepType === this.stepTypes.OFFICE
          ) || {}).responsibleId;
          if (officeId) {
            if (!this.wizardData.document) {
              this.error.message = 'No es posible encontrar configuración '
                + 'de numeración para este documento';
              return false;
            }

            this.searchingConfig = true;
            const document = this.documents.find(
              (doc) => doc.opcionId === this.wizardData.document
            );
            const { data: { configFolios = [] } } = await getSheetsConfig({
              tipoDocId: document.opcionId,
              alcanceId: officeId
            });

            this.searchingConfig = false;
            if (!configFolios.length) {
              this.error.message = 'No existe configuración de numeración para este documento';
            }
            // eslint-disable-next-line consistent-return
            return configFolios.length > 0;
          }
        }

        if (this.step.steps[this.step.steps.length - 1].rolType === this.rolTypes.REVIEWER) {
          this.error.message = 'El último paso no puede ser revisor';
          return false;
        }
        this.adjustStepsNumbers();
        // eslint-disable-next-line consistent-return
        return true;
      } finally {
        this.searchingConfig = false;
      }
    },
    getStepData() {
      const isResolution = this.wizardData.documentTypeValue === 'RES' || this.wizardData.documentTypeValue
        === 'RES_EX';
      const isControlResolution = this.wizardData.documentTypeValue === 'RES_AFE';
      const typeFile = this.wizardData.documentTypeValue || this.wizardData.documentTypeName;

      return {
        fileNumber: this.wizardData.fileNumber,
        fileUrl: this.wizardData.fileUrl,
        fileName: this.wizardData.fileName,
        typeFlowId: this.wizardData.fileType,
        typeFlowText: `${this.wizardData.fileType} - `,
        fileType: this.wizardData.fileType,
        number: this.wizardData.fileNumber,
        privado: 'N',
        typeFileDescription: typeFile,
        isResolution,
        isControlResolution,
        ...this.step
      };
    },
    onSetSignaturePositionChange(newValue) {
      this.$emit('update-steps');
      this.$emit('loaded');

      if (!newValue) {
        this.step.signaturesDropped = {};
        this.removeSignaturesDropped();
      }
    },
    selectNumerationOffice(office) {
      this.addActionsOffice(office, this.step.office.documentInfo);
    }
  },
  async created() {
    this.searchingConfig = true;
    try {
      this.step.name = this.wizardData.fileResumen;
      this.step.description = this.wizardData.fileDescription;
      this.step.mainFile.path = this.wizardData.fileUrl;
      this.step.mainFile.name = this.wizardData.fileName;
      const TIPO_RESPUESTA_MAP = 2;
      await this.getWorkerData({
        tipoRespuesta: TIPO_RESPUESTA_MAP,
        elementoId: this.currentUser.id,
        referenciaId: this.company.id,
        filtros: 'nombre:OFICINA_INT,OFICINA_EXT'
      });
      const { data: { opciones } } = await listOptions({
        grupoOpcion: 'tipos.documentos-ed',
        deshabilitado: 'no',
        agrupar: 'si'
      });
      this.documents = opciones;
      const option = this.documents.find((doc) => doc.opcionId === this.wizardData.document);
      this.step.documentTypeId = option?.opcionId;
      const numationAction = this.checkIfDocumentHasAutomaticNumerationActions(
        {
          ...option,
          extra: JSON.parse(option.extra || '{}')
        }
      );
      if (!numationAction) {
        await this.fetchOffices([{ key: 'isOffice', filter: 'esOficina:Y' }]);
        await this.setOffice();
      }
    } finally {
      this.searchingConfig = false;
    }
  },
  async mounted() {
    await this.fetchUserGroups();
  }
};
</script>
<style>

.step-wrapper {
  border: 1px solid #662483;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  margin-top: 20px;
}

.step-number {
  position: absolute;
  top: -10px;
  left: -4px;
  padding: 2px 8px;
  background: #16c86b;
  border-radius: 50%;
  color: white;
  font-size: 12px;
}

.step-delete {
  position: absolute;
  top: -10px;
  right: -4px;
  font-size: 10px;
  color: #b11e0b;
  cursor: pointer;
}

.step-rol {
  position: absolute;
  bottom: -10px;
  right: -1px;
  padding: 2px 8px;
  background: #671e85;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-type {
  position: absolute;
  bottom: -10px;
  left: -1px;
  padding: 2px 8px;
  background: #155f87;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-name {
  padding: 8px 0;
}
</style>
